//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUserInfo, isWeiXin, system } from '@/util/const'
import  LoginWindow from './LoginWindow';
import  BoxWindow from './BoxWindow';
import {getQueryVariable } from '@/util/const'

export default {
  components: {
    'LoginWindow': LoginWindow,
     'BoxWindow': BoxWindow,
  },
  data () {
    return {
      openInBrowser: false,
      status: false,
      phoneNumber: '',
      loginShow: false,
      boxShow:false,
      tagHref: {
        series_update: 'openpage://3520',
        recommend_update: 'openpage://8600'
      },
      bg: this.$t('birthday.bg'),
      resultType: 2,
      isIos: system(),
      isWeiXin: isWeiXin(),

    }
  },
  created () {
    let from = getQueryVariable('from')
    if (from === "sms") {
      this.$http.clickRate('birthday_sms')
    }else {
      this.$http.clickRate('birthday_email')
    }
  },
  mounted () {

  },
  methods: {
    hideBox() {
      this.boxShow = false;
    },
    hideLogin(data){
      if(data){
      this.phoneNumber = data;
        this.status = true
       this.sendGift()
      }
      this.loginShow = false
      },
    sendGift (){
      this.$http.get(`/ticket_racing/birthdaygift/sendGift`, { phone: this.phoneNumber }).then(res => {
       this.resultType = res.data.body.status
        this.boxShow = true;
      })
    },
    detail () {
      this.$alert({
        content: {
          title: this.$t('birthday.title'),
          list: this.$t('birthday.rule')
        }
      })
    },
    receive () {
      if (!this.status) {
        return
      }
      if (this.isWeiXin) {
        this.openInBrowser = true
        return
      }
        this.loginShow = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/birthday/index.vue